import { get, put, patch, post, del } from "helpers/api_helper"
import { normalizeAdminListFilters } from "helpers/adminListQueryPolicy"
import { writeAdminQuery } from "./listQuery"

const config = correlationId => ({ timeout: 10000, ...(correlationId && { headers: { "X-Correlation-Id": correlationId } }) })
export const getAdmins = async (filters = {}, options = {}) => {
  const query = new URLSearchParams({ ...normalizeAdminListFilters(filters), ...options })
  const response = await get("/admin/platform-admins?" + query, { timeout: 10000 })
  const data = response?.data
  if (!Array.isArray(data?.results) || !Number.isInteger(data.totalResults) || data.totalResults < 0
    || !Number.isInteger(data.page) || data.page < 1 || !Number.isInteger(data.limit) || data.limit < 1
    || data.results.some(row => !row?.id || !["admin", "superAdmin"].includes(row.role))) {
    throw new Error("Invalid admin directory response")
  }
  return { ...response, data: { ...data, queryKey: writeAdminQuery(filters, options) } }
}
export const getAdminInfo = async id => {
  const response = await get("/accounts/" + id, { timeout: 10000 })
  if (!response?.data?.id || !["admin", "superAdmin"].includes(response.data.role)) throw new Error("Admin not found")
  return response
}
export const createAdmin = (data, correlationId) => post("/admin/accounts", data, config(correlationId))
export const updateAccount = (id, data, correlationId) => put("/admin/accounts/" + id, data, config(correlationId))
export const updateStatus = (id, status, data = {}, correlationId) => patch("/admin/accounts/" + id + "/status", { ...data, status }, config(correlationId))
export const deleteAdmin = (id, data = {}, correlationId) => del("/admin/accounts/" + id, data, config(correlationId))
export const getCommandResult = correlationId => get("/admin/account-commands/" + encodeURIComponent(correlationId), { timeout: 5000 })
export const resetPassword = email => post("/accounts/reset-password", { email }, { timeout: 10000 })
export const setPassword = (id, data) => patch("/accounts/" + id + "/set-password", data, { timeout: 10000 })
